<template>
    <v-main class="pa-2" fluid>

        <v-row>
            <v-btn @click="dialog = true" color="primary" dark>Add Aircraft</v-btn>
                <v-dialog v-model="dialog" @keydown.esc="dialog = false" persistent max-width="600px">
                    <v-card color="lighten-1">
                        <v-toolbar>
                                <v-toolbar-title>
                                    <span class="headline">{{formTitle}}</span>
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-form ref="form" v-model="valid" class="row">
                                        <v-col cols="12" md="12">
                                            <v-text-field label="Name" v-model="editedItem.name" :rules="nameRules" required></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="12">
                                            <v-text-field label="Spots" v-model.number="editedItem.spots" :rules="req" required type="number"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="12">
                                            <v-text-field label="Description" v-model="editedItem.description" 
                                            ></v-text-field>

                                        </v-col>
                                    </v-form>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                            <v-btn color="blue darken-1" type="submit" @click="save" :disabled="!valid">Save</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            
        </v-row>

        <v-data-table
            :headers="headers"
            :items="plains"
            :items-per-page="10"
            class="elevation-1">
                <template v-slot:item.actions="{ item }">

                <v-btn icon small @click="edit(item)">
                  <v-icon center>mdi-pencil</v-icon> 
                </v-btn>

                <!-- <v-btn icon small color="red" @click="deletePlain(item.id)">
                  <v-icon center>mdi-delete-forever</v-icon> 
                </v-btn> -->

                </template>

                <template v-slot:item.status="{ item }">
                    <v-switch :success="item.status == 1 ? true : false" @change="updateStatus(item)"
                                  v-model="item.status"
                                  inset
                                  :label="getUserSwitchLabel(item.status)"
                            ></v-switch>
                </template>
            </v-data-table>
    </v-main>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        data() {
            return {
                headers: [
                    { text: '', value: 'data-table-expand' },
                    { text: 'Name', align: 'start', sortable: true, value: 'name', },
                    { text: 'Description', align: 'start', sortable: true, value: 'description', },
                    { text: 'Spots', align: 'start', sortable: true, value: 'spots', },
                    { text: 'status', align: 'start', sortable: true, value: 'status', },
                    { text: ' ', align: 'start', sortable: true, value: 'actions', },
                ],

                dialog: false,
                editedIndex: -1,
                valid: true,
                lazy: true,
                isEditing: null,
                
                editedItem: {
                    name : '',
                    spots : 0,
                    description : ''
                },
                nameRules: [
                    v => !!v || 'Name is required',
                ],
                req: [
                    v => !!v || 'Required',
                ],
            }
        },

        mounted () {
            this.$store.dispatch('fetchPlains')
        },


        computed: {
            ...mapState(['plains']),

            formTitle () {
                return this.editedIndex === -1 ? 'New Aircraft' : 'Edit Aircraft'
            },
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
        },
        
        methods: {

            edit(item) { 

                this.editedIndex = this.plains.indexOf(item);
                this.editedItem = Object.assign({}, item)

                this.dialog = true
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                  this.editedItem = Object.assign({}, this.defaultItem)
                  this.editedIndex = -1
                  
                })
              },


              updateStatus(item) {

                this.editedIndex = this.plains.indexOf(item)
                this.editedItem = Object.assign({}, item)

                axios.put('/api/plains/updateStatus/' + this.editedItem.id, this.editedItem)
                        .then( response => {
                            
                            this.close();
                            
                        })
                        .catch( err => {
                            console.log( err )
                        })
            },


              save () {

                if (this.editedIndex > -1) {


                    axios.put('/api/plains/' + this.editedItem.id, this.editedItem)
                        .then( response => {

                            Object.assign(this.plains[this.editedIndex], this.editedItem)
                            this.close();
                            
                        })
                        .catch( err => {
                            console.log( err )
                        })

                  
                } else {


                    axios.post('/api/plains', this.editedItem)
                    .then( response => {

                        this.plains.push(this.editedItem)

                        this.close();
                        
                    })
                    .catch( err => {
                        console.log( err )
                    })
                  
                }

              }
          }
    }
</script>